import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { Background } from 'src/theme-v2/background';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flexDirection: 'row',
    borderRadius: 24,
    borderWidth: 1,
    borderColor: neutrals.coldGrays.pearl,
    backgroundColor: neutrals.white,
    ...getBoxShadow({
      color: neutrals.black,
      offsetX: 0,
      offsetY: 2,
      opacity: 0.1,
      blurRadius: 12,
    }),
  },
  containerV3: {
    overflow: 'visible',
    flexDirection: 'row',
    borderRadius: 24,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    ...getBoxShadow({
      color: neutrals.black,
      offsetX: 12,
      offsetY: 12,
      opacity: 0.15,
      blurRadius: 20,
    }),
    backdropFilter: 'blur(32px)',
    WebkitBackdropFilter: 'blur(32px)',
  },
  containerInner: {
    paddingHorizontal: 8,
    paddingVertical: 16,
  },
  containerInnerV3: {
    overflow: 'hidden',
    flexDirection: 'row',
  },
  optionsContainerV3: {
    overflow: 'hidden',
  },
  containerToolOptions: {
    position: 'absolute',
    left: 0,
  },
  containerToolTiles: {
    width: '100%',
  },
  containerToolsContent: {
    gap: 4,
  },
  iconClose: {
    position: 'absolute',
    top: -12,
    right: -12,
    width: 40,
    height: 40,
    padding: 8,
    backgroundColor: brand.main.water,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  scrollview: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 4,
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
  separator: {
    backgroundColor: Background.BackgroundColorNeutral,
    height: 1,
    width: '90%',
    alignSelf: 'center',
  },
});
